import { create } from "zustand";

export interface LoadingSpinnerStore {
  loadingSpinner: boolean;
  setLoadingSpinner: (loadingSpinner: boolean) => void;
}

export const useLoadingSpinnerStore = create<LoadingSpinnerStore>((set) => ({
  loadingSpinner: false,
  setLoadingSpinner: (loadingSpinner) => set({ loadingSpinner }),
}));
